import fetch from 'utils/fetch';
import md5 from 'js-md5';

export function loginByEmail(username, password) {
  password = md5(password);
  const data = {
    username,
    password
  };
  return fetch({
    url: '/login/loginbypwd',
    withCredentials: true,
    method: 'post',
    data
  });
}

export function loginByToken(token) {
  const data = {
    token
  };
  return fetch({
    url: '/sso/login/loginByToken',
    withCredentials: true,
    method: 'post',
    data
  });
}

export function logout() {
  return fetch({
    url: '/sso/logout',
    withCredentials: true,
    method: 'post'
  });
}

export function getInfo(token) {
  return fetch({
    url: '/qitongcha/enweb/user/info',
    withCredentials: true,
    method: 'post'
  });
}

export function getPermission(token) {
  return fetch({
    url: '/qitongcha/enweb/user/permission',
    withCredentials: true,
    method: 'post'
  });
}




// WEBPACK FOOTER //
// ./src/api/login.js